"use strict";

/* -------------------------------------------------------------------------- */
/*                        HIDDEN FIGURE CAPTION BUTTON                        */
/* -------------------------------------------------------------------------- */
const figAlt = document.querySelectorAll("figure.is-style-hidden-caption");
figAlt.forEach(element => {
  const figAltCap = element.querySelector("figcaption");
  if (figAltCap) {
    element.insertAdjacentHTML("beforeend", '<button class="show-caption-btn">i</button>');
    const capBtn = element.querySelector("button.show-caption-btn");
    capBtn.addEventListener("click", () => {
      figAltCap.classList.toggle("show");
    });
  }
});

/* -------------------------------------------------------------------------- */
/*                            Main and mobile menu                            */
/* -------------------------------------------------------------------------- */
const theBodyClasses = document.body.classList;
const mainHeader = document.querySelector(".site-header");
const menuBtn = document.querySelector(".nav-bar__menu-toggle");
const menuItemGrandparent = document.querySelectorAll(".menu-item-grandparent");
const navTopTitleBtn = document.querySelectorAll(".top-level-sub-menu-toggle");
const subMenu = document.querySelectorAll(".sub-menu.depth-0");
const subMenuTrigger = [...navTopTitleBtn, ...subMenu];

/* Open Mobile menu on hamburger click -------------------------------------- */
menuBtn.addEventListener("click", () => {
  if (theBodyClasses.contains("main-menu-open")) {
    theBodyClasses.remove("main-menu-open");
    hideAllSubMenus();
  } else {
    theBodyClasses.add("main-menu-open");
  }
});

/* Only run certain functions on media query -------------------------------- */
const mediaQuery = window.matchMedia("(min-width: 960px)");
function mediaQueryChange(mediaQuery) {
  if (mediaQuery.matches) {
    subMenuTrigger.forEach(element => {
      ["mouseover", "focus"].forEach(evt => element.addEventListener(evt, showSubMenu, false));
      ["mouseout", "blur"].forEach(evt => element.addEventListener(evt, hideAllSubMenus, false));
    });
  } else {
    subMenuTrigger.forEach(element => {
      ["mouseover", "focus", "mouseout", "blur"].forEach(evt => element.removeEventListener(evt, showSubMenu, false));
      ["mouseout", "blur"].forEach(evt => element.removeEventListener(evt, hideAllSubMenus, false));
    });
    navTopTitleBtn.forEach(element => {
      element.addEventListener("click", toggleSubMenu, false);
    });
  }
}
mediaQuery.addEventListener("change", mediaQueryChange);
mediaQueryChange(mediaQuery);
function toggleSubMenu(e) {
  mainHeader.classList.toggle("sub-menu-open");
  e.target.closest(".menu-item-grandparent").classList.toggle("is-open");
}
function showSubMenu(e) {
  mainHeader.classList.add("sub-menu-open");
  e.target.closest(".menu-item-grandparent").classList.add("is-open");
}
function hideAllSubMenus() {
  mainHeader.classList.remove("sub-menu-open");
  menuItemGrandparent.forEach(function (item) {
    item.classList.remove("is-open");
  });
}

/* Close the mobile menu on click outside ----------------------------------- */
document.addEventListener("click", evt => {
  let targetEl = evt.target; // clicked element
  do {
    if (targetEl == mainHeader) {
      // This is a click inside, does nothing, just return.
      return;
    }
    // Go up the DOM
    targetEl = targetEl.parentNode;
  } while (targetEl);
  // This is a click outside.
  if (theBodyClasses.contains("main-menu-open")) {
    theBodyClasses.remove("main-menu-open");
    hideAllSubMenus();
  }
});